
// TODO
// see http://tobyho.com/2011/01/28/checking-types-in-javascript/

export function valueFactory() {
  'use strict';

  /**
   * @memberOf farmnet.admin.shop
   * @param {*} any
   * @returns ValueTester
   */
  function value(any) {
    return new ValueTester(any);
  }

  /**
   * @memberOf farmnet.admin.shop
   * @param {*} any
   * @constructor
   */
  function ValueTester(any) {
    this.value = any;

    this.isNumber = function() {
      return angular.isNumber(this.value);
    };
    this.toBeNumber = this.isNumber;

    this.isBoolean = function() {
      return this.value === true || this.value === false;
    };
    this.toBeBoolean = this.isBoolean;

    this.isString = function() {
      return angular.isString(any);
    };
    this.toBeString = this.isNumber;

    this.isDefined = function() {
      return angular.isDefined(this.value);
    };
    this.toBeDefined = this.isDefined;

    this.isUndefined = function() {
      return angular.isUndefined(this.value);
    };
    this.toBeUndefined = this.isUndefined;

    this.isObject = function() {
      return angular.isObject(this.value);
    };
    this.toBeObject = this.isObject;

    this.isArray = function() {
      return angular.isArray(this.value);
    };
    this.toBeArray = this.isArray;

    this.isInstanceOf = function(constructor) {
      return this.value instanceof constructor;
    };

    /**
     * Test for duck typing.
     * The given value must be an object, otherwise
     * false is returned. (TODO use contract?)
     * Only checks if this value object has all properties
     * of the given object. But not if the properties have
     * compatible types.
     * @param {object} object
     * Must be an object.
     */
    this.isLike = function(object) {
      if (!this.isObject() || !value(object).isObject()) {
        return false;
      }

      for (var key in object) {
        if (object.hasOwnProperty(key) && !this.value.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    };
  }

  return value;
}